var render = function render(){var _vm=this,_c=_vm._self._c;return _c('l-control',{ref:"con",attrs:{"position":"topright"}},[_c('b-button',{staticClass:"shadow-lg",attrs:{"variant":"dark"},on:{"click":_vm.handleClick}},[_c('img',{staticClass:"mx-n1",staticStyle:{"height":"1.5em","filter":"invert(90%)"},attrs:{"src":require("../assets/interface/crosshair.svg")}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }